import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getBookById } from "../services/api";

function BookDetails() {
  const { id } = useParams();
  const [book, setBook] = useState(null);

  useEffect(() => {
    getBookById(id).then(data => {
      setBook(data);
    });
  }, [id]);

  if (!book) {
    return <p>Loading book details...</p>;
  }

  return (
    <div className="container">
      <h3>Book Details</h3>

      <p><b>Book Name:</b> {book.title}</p>
      <p><b>Author:</b> {book.author}</p>
      <p><b>Publisher:</b> {book.publisher}</p>
      <p><b>Published Date:</b> {book.publishedDate}</p>
      <p><b>Summary:</b> {book.description}</p>

      <br />
      <Link to="/">← Back to Book List</Link>
    </div>
  );
}

export default BookDetails;
